// ============================================================================
// DASHBOARD ENDPOINTS — Phase 1 skeleton
// ============================================================================
// Backend: DashboardController → all POST endpoints accept ReportFilterRequest body.

import { buildEndpoint } from './base.endpoints';

const BASE_PATH = '/Dashboard';

export const dashboardEndpoints = {
  bookingOverview:   () => buildEndpoint(`${BASE_PATH}/booking-overview`),
  revenue:           () => buildEndpoint(`${BASE_PATH}/revenue`),
  approval:          () => buildEndpoint(`${BASE_PATH}/approval`),
  forwardOccupancy:  () => buildEndpoint(`${BASE_PATH}/forward-occupancy`),
  agentCorporate:    () => buildEndpoint(`${BASE_PATH}/agent-corporate`),
};

export default dashboardEndpoints;
